import React, { useState } from 'react';

import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import { useContextStore } from '../../stores/storeRoot';
import SecurityTrim from '../../services/auth/SecurityTrim';
import { CropConnectRoleDefinitions } from '../../services/cropConnectApiClient';
import { MainContainer } from '../../styles/styles';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import AddBanner from '../../presentation/features/eShop_banner/AddBanner/AddBanner';
import ProductsReport from '../../presentation/reports/ProductsReport/ProductsReport';
import { AlertModal } from '../../presentation/features/eShop_banner/AlertModal/AlertModal';

const MyOrders = () => {
  const { t } = useI18n();
  const { activeBpNumber, businessPartners } = useContextStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasMultipleBPs =
    Array.isArray(businessPartners) && businessPartners.length > 1;

  const handleBannerClick = () => {
    if (hasMultipleBPs) {
      setIsModalOpen(true);
    } else {
      handleNavigateToEShop();
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleNavigateToEShop = () => {
    const eShopUrl = process.env.REACT_APP_ESHOP_URL;
    if (eShopUrl) {
      const encodedReturnUrl = encodeURIComponent(window.location.href);
      const fullUrl = `${eShopUrl}${encodedReturnUrl}`;
      window.open(fullUrl, '_self');
    }
  };

  const handleModalConfirm = () => {
    handleNavigateToEShop();
    setIsModalOpen(false);
  };

  return (
    <MainContainer>
      <PageHeader
        title={t(TranslationKeys.orderedAndDeliveredProducts_report_title)}
      />
      <SecurityTrim
        requiredGlobalRoles={[CropConnectRoleDefinitions.Internal_Employee]}
      >
        <AddBanner onClick={handleBannerClick} />
      </SecurityTrim>
      <SecurityTrim
        requiredBusinessPartnerRoles={[CropConnectRoleDefinitions.Grower]}
      >
        <ProductsReport />
      </SecurityTrim>

      {hasMultipleBPs && (
        <AlertModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          onConfirm={handleModalConfirm}
          businessPartnerName={activeBpNumber || ''}
        />
      )}
    </MainContainer>
  );
};

export default MyOrders;
